'use strict';

const SELECTOR = '.js-form';

export default function init() {
    const forms = document.querySelectorAll(SELECTOR);

    if (!forms.length) {
        return;
    }

    const search = new URLSearchParams(window.location.search);

    if (search.has('form_message')) {
        const message = search.get('form_message');

        forms.forEach(form => {
            form.querySelectorAll('.form__fields-wrapper, .form__submit-wrapper').forEach(el => el.remove());
            const messageEl = document.createElement('div');
            messageEl.classList.add('form__message');
            messageEl.textContent = message;
            form.appendChild(messageEl);
            form.scrollIntoView({ behavior: 'smooth' });
        });
    }
}
